var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscardGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05563 1.25C4.84283 1.25 4.64004 1.33053 4.49154 1.47189C4.34325 1.61303 4.26115 1.80313 4.26115 2V2.75H8.73911V2C8.73911 1.80313 8.65701 1.61303 8.50873 1.47189C8.36022 1.33053 8.15744 1.25 7.94463 1.25H5.05563ZM10.0392 2.75V2C10.0392 1.46753 9.81688 0.958149 9.42337 0.583571C9.03008 0.209204 8.49804 0 7.94463 0H5.05563C4.50222 0 3.97018 0.209203 3.57689 0.583571C3.18338 0.958149 2.9611 1.46753 2.9611 2V2.75H0.650025C0.291026 2.75 0 3.02982 0 3.375C0 3.72018 0.291026 4 0.650025 4H0.794353V13C0.794353 13.5325 1.01663 14.0419 1.41014 14.4164C1.80343 14.7908 2.33547 15 2.88888 15H10.1114C10.6648 15 11.1968 14.7908 11.5901 14.4164C11.9836 14.0419 12.2059 13.5325 12.2059 13V4H12.3505C12.7095 4 13.0005 3.72018 13.0005 3.375C13.0005 3.02982 12.7095 2.75 12.3505 2.75H10.0392ZM2.0944 4V13C2.0944 13.1969 2.1765 13.387 2.32478 13.5281C2.47329 13.6695 2.67607 13.75 2.88888 13.75H10.1114C10.3242 13.75 10.527 13.6695 10.6755 13.5281C10.8238 13.387 10.9059 13.1969 10.9059 13V4H2.0944Z",
    fill: "#9296AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscardGray);
export default __webpack_public_path__ + "static/media/discardGray.619676af1613680742483900832cea09.svg";
export { ForwardRef as ReactComponent };